<template>
  <v-dialog
    :value="showDialog"
    width="900"
    persistent
    @input="closeDialog"
  >
    <v-card>
      <v-toolbar
        dark
        dense
        color="blue darken-1"
      >
        <v-toolbar-title>
          {{ title }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          @click="closeDialog"
        >
          <v-icon small>
            close
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text
        ref="scroller"
        class="dialog-conente-scroll"
      >
        <div
          class="pa-2"
        >
          <div
            v-if="detail"
          >
            <div class="grey--text caption mb-2">
              問題描述
            </div>
            <Message
              :detail="detail"
              hideIcon
            />
            <template v-if="detail.replies.length">
              <v-divider class="my-4" />
              <div class="grey--text mb-4 caption">
                回覆
              </div>
              <div
                v-for="item in detail.replies"
                :key="item.cid"
                class="mb-4"
              >
                <Message
                  :parent="detail"
                  :detail="item"
                  @reload="fetchDetail();$emit('reload')"
                />
              </div>
            </template>
            <v-divider class="my-4" />
          </div>
          <div
            v-if="detail && detail.isLike != '0'"
            class="text-xs-center pt-2 pb-4 orange--text"
          >
            <v-chip
              color="red"
              text-color="white"
            >
              已評價：
              <span
                v-if="detail.isLike == '-1'"
              >
                不滿意
              </span>
              <span
                v-if="detail.isLike == '1'"
              >
                一般
              </span>
              <span
                v-if="detail.isLike == '2'"
              >
                很好
              </span>
            </v-chip>
          </div>
          <v-layout v-else-if="detail && (detail.banReply==1 || detail.status === 'done')">
            <v-spacer />
            <v-btn
              class="orange white--text"
              @click="showLikeDialog = true"
            >
              評價
            </v-btn>
            <v-spacer />
          </v-layout>

          <v-alert
            v-if="detail?.at > 0"
            :value="true"
            color="teal"
            outline
            style="border-radius: 5px;"
            class="mb-3"
          >
            🕘倉庫客服( 上班 / 工作 )時間：每日 09:00-18:00<br>
            收到留言後，我們會在上班時間儘快回覆，謝謝您的理解！
          </v-alert>
          <v-layout v-if="!isCreate && detail && !showEdit && detail.banReply != 1 && detail.status !== 'done' && detail.isLike == '0'">
            <v-spacer />
            <v-btn
              v-if="canClose"
              class="error"
              @click="banReply"
            >
              問題已解決
            </v-btn>
            <v-btn
              class="info mx-4"
              @click="handleClickShowEdit"
            >
              繼續提問
            </v-btn>
            <v-spacer />
          </v-layout>
          <div v-if="!showDialog" />
          <WalletOrderComment
            v-else-if="isCreate && from === 'wallet-order'"
            @created="handleCreated"
          />
          <WalletOrderComment
            v-else-if="isCreate && from === 'wallet-dgorder'"
            type="代採購匯款"
            @created="handleCreated"
          />
          <DgorderComment
            v-else-if="isCreate && from === 'dgorder'"
            :otherData="otherData"
            @created="handleCreated"
          />
          <ApplyThirdPartyJyComment
            v-else-if="isCreate && from === 'applyThirdPartyJy'"
            @created="handleCreated"
          />
          <template v-else-if="isCreate || showEdit">
            <v-alert
              v-if="showTips"
              :value="true"
              border="left"
              color="warning"
              outlined
              dense
            >
              2月20日2時-2月24日2時，客服系統升級維護，維護期間，將於每日11時至12時以及23時至24時回覆，如使用時碰到問題請先於
              <a
                :href="$store.state.option.optionApp.fe_line_link.newbieLink"
                target="_blank"
                class="white--text"
              >Line社群</a>
              提問。
            </v-alert>

            <v-form
              ref="form"
            >
              <v-textarea
                v-model="model.content"
                :rows="3"
                :rules="[$store.state.validationRules.required, contentLenRule]"
                :placeholder="$store.state.project === 'mgb-pc' ? '請詳述碰到的問題（關於訂單問題，請以文字提供代採購訂單號）' : '請詳述碰到的問題（關於包裹或訂單問題，請以文字提供包裹運單號、集運訂單號）'"
                solo
                label="申訴內容"
                auto-grow
                @focus="$refs.HotQa.open()"
              />
            </v-form>
            <template
              v-if="matchQaList.length"
            >
              <div
                class="subTitle"
              >
                猜你想問：
              </div>
              <div
                v-for="qa in matchQaList"
                :key="qa.id"
                class="ml-2 my-1"
              >
                <template v-if="qa.type === 'canpack'">
                  <a
                    style="text-decoration: none"
                    @click="showParcelCanPack = true"
                  >
                    <b style="color:#ff806b">能寄嗎</b>
                    <img
                      src="../parcel/images/nengjima.png"
                      height="22"
                      class="mr-2"
                      style="vertical-align: middle;"
                    >
                  </a>
                  <div
                    v-if="showParcelCanPack"
                    style="width:315px"
                  >
                    <ParcelCanPack />
                  </div>
                </template>
                <template v-else>
                  <div>
                    <div
                      class=""
                    >
                      <div
                        class="ql-editor blue--text cursor-pointer"
                        @click="toggleShowQa(qa.poid)"
                        v-html="qa.title"
                      />
                      <div
                        v-if="showQaids.includes(qa.poid)"
                        class="mb-4"
                      >
                        <div @click.prevent="hanldeClickContent">
                          <div
                            style="width: 600px;"
                            class="ql-editor"
                            v-html="qa.content"
                          />
                        </div>
                        <div
                          v-if="qa.tool === '$[能寄嗎]'"
                        >
                          <div style="width:315px">
                            <ParcelCanPack />
                          </div>
                        </div>
                        <div
                          v-else-if="qa.tool === '$[體積重量能寄嗎]'"
                        >
                          <div style="width:315px">
                            <CanPackSizeContent
                              inject
                            />
                          </div>
                        </div>
                        <div
                          v-else-if="qa.tool === '$[運費試算]'"
                        >
                          <div>
                            <ShippingRatesCalcContent
                              inject
                              width="315"
                              hideHint
                            />
                          </div>
                        </div>
                        <div
                          v-else-if="qa.tool === '$[海快行事曆]'"
                        >
                          <CalendarSe
                            inject
                          />
                        </div>
                        <div
                          v-else-if="qa.tool === '$[空運行事曆]'"
                        >
                          <CalendarAir
                            inject
                          />
                        </div>
                        <div
                          v-else-if="qa.tool === '$[倉庫地址]'"
                        >
                          <div style="width:700px;">
                            <Address
                              inject
                            />
                          </div>
                        </div>
                        <div
                          v-else-if="qa.tool === '$[搜尋]'"
                        >
                          <div style="width:300px;">
                            <SearchTool hideHint />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </template>

            <UploadImage
              v-model="model.upyunFiles"
              dir="comment"
              class="my-4"
            />

            <v-btn
              :loading="submitLoading"
              block
              color="info"
              @click="submit"
            >
              送出
            </v-btn>
          </template>
        </div>
      </v-card-text>

      <LikeDialog
        :showDialog.sync="showLikeDialog"
        :propModel="detail"
        @liked="handleLiked"
      />

      <HotQa
        ref="HotQa"
        :isCreate="isCreate"
      />
      <LineNotifyConfirmDialog
        ref="LineNotifyConfirmDialog"
      />
    </v-card>
  </v-dialog>
</template>
<script>
import UploadImage from './components/UploadImage'
import Message from './components/Message'
import LikeDialog from './components/LikeDialog'
import ParcelCanPack from '../parcel/components/CanPack'
import CanPackSizeContent from '../parcel/components/CanPackSizeContent'
import CalendarSe from '../introduc/Se'
import CalendarAir from '../introduc/Air'
import ShippingRatesCalcContent from '../components/ShippingRatesCalcContent'
import Address from '../components/WarehousesTab'
import SearchTool from './components/SearchTool.vue'
import HotQa from './components/HotQa.vue'
import WalletOrderComment from './components/WalletOrderComment.vue'
import DgorderComment from './components/DgorderComment.vue'
import ApplyThirdPartyJyComment from './components/ApplyThirdPartyJyComment.vue'
import dayjs from 'dayjs'
import LineNotifyConfirmDialog from '@/components/LineNotifyConfirmDialog.vue'

export default {
  components: {
    UploadImage,
    Message,
    LikeDialog,
    ParcelCanPack,
    CanPackSizeContent,
    ShippingRatesCalcContent,
    CalendarSe,
    CalendarAir,
    Address,
    SearchTool,
    HotQa,
    WalletOrderComment,
    DgorderComment,
    ApplyThirdPartyJyComment,
    LineNotifyConfirmDialog,
  },
  props: {
    showDialog: Boolean,
    cid: String,
    createTimesData: Object,
    from: String,
    listLen: Number,
    otherData: Object,
  },
  data () {
    return {
      model: {
        content: '',
        upyunFiles: [],
      },
      submitLoading: false,
      detail: null,

      contentLenRule: (v) => {
        if (v) return v.trim().getLen() >= 5 || '最少輸入5個漢字'
        return true
      },

      showEdit: false,
      showLikeDialog: false,
      showParcelCanPack: false,

      qaList: [],
      showQaids: [],
      showTips: dayjs().isBefore('2023-02-24'),
    }
  },
  computed: {
    isCreate () {
      return !this.cid
    },
    title () {
      if (this.from === 'wallet-order') {
        return '儲值申訴'
      } else if (this.from === 'wallet-dgorder') {
        return '代採購匯款申訴'
      } else if (this.from === 'dgorder') {
        return '代購售後服務'
      } else if (this.from === 'applyThirdPartyJy') {
        return '集運商開通申請'
      }
      return this.isCreate ? '提交新的申訴' : '申訴詳情'
    },
    hasUrl () {
      return /https?:\/\//.test(this.model.content)
    },
    user () {
      return this.$store.state.userData
    },
    remainder () {
      if (!this.createTimesData) return
      return Math.max(0, this.$calc(`${this.createTimesData.maxTimes}+${this.createTimesData.knapMaxTimes}-${this.createTimesData.curTimes}-${this.createTimesData.knapCurTimes}`))
    },
    matchQaList () {
      const list = []
      if (this.hasUrl) {
        list.push({
          type: 'canpack',
          id: 'canpack',
        })
      }

      const content = this.model.content.trim()
      if (content) {
        const words = []
        if (content.length >= 2) {
          for (let wordLen = content.length; wordLen >= 2; wordLen--) {
            for (let i = 0; i < content.length; i++) {
              const w = content.substring(i, i + wordLen)
              if (w.length > 1) {
                words.push(w)
              }
            }
          }
        } else {
          // words.push(content)
        }
        words.sort((a, b) => b.length - a.length)
        this.qaList.forEach(item => {
          const keys = item.excerpt ? item.excerpt.split(',') : []
          for (let i = 0; i < words.length; i++) {
            const word = words[i]
            if (keys.includes(word)) {
              list.push({
                ...item,
              })
              break
            }
          }
        })
      }
      return list
    },
    canClose () {
      return !this.isCreate
    },
  },
  watch: {
    cid () {
    },
    matchQaList () {
      if (this.matchQaList.length === 1) {
        this.showQaids = [this.matchQaList[0].poid]
      }
    },
    async showDialog () {
      this.showEdit = false
      if (this.showDialog) {
        if (this.$store.state.project === 'pc') {
          this.getQaList()
        }
      }
      if (this.showDialog && this.cid) {
        await this.fetchDetail()
        await this.$nextTick()
        this.$refs.scroller.scrollTop = this.$refs.scroller.scrollHeight
      } else {
        this.detail = null
      }
    }
  },
  mounted () {
    setInterval(() => {
      if (this.showDialog && this.cid && !this._isDestroyed) {
        this.fetchDetail()
      }
    }, 1000 * 5)
  },
  methods: {
    async getQaList () {
      this.$store.dispatch('comment/getQalistForCache').then(list => {
        if (list) {
          this.qaList = list
        }
      })
      const res = await this.$store.dispatch('post/index', {
        type: 'qa',
        pageSize: -1,
      })
      if (!res.data.error) {
        this.qaList = res.data.list.map(item => {
          const r = item.content.match(/(\$\[.*\])/)
          if (r) {
            item.content = item.content.replace(/(\$\[.*\])/, '')
            item.tool = r[0]
          }
          return item
        })
        this.$store.commit('comment/setQaList', this.qaList)
      }
    },
    toggleShowQa (id) {
      if (this.showQaids.includes(id)) {
        this.showQaids.splice(this.showQaids.indexOf(id), 1)
      } else {
        // this.showQaids.push(id)
        this.showQaids = [id]
      }
    },
    closeDialog () {
      this.$emit('update:showDialog', false)
    },
    async fetchDetail () {
      const res = await this.$store.dispatch('comment/view', {
        cid: this.cid,
      })
      if (!res.data.error) {
        this.detail = res.data.model
      }
    },
    async banReply () {
      const res = await this.$store.dispatch('comment/banReply', {
        cid: this.cid,
      })
      if (!res.data.error) {
        await this.fetchDetail()
        this.showLikeDialog = true
      }
    },
    async submit () {
      if (!this.$refs.form.validate()) {
        return
      }
      try {
        this.submitLoading = true
        if (!this.model.content.length) {
          this.$toast('請輸入申訴內容')
          return
        }
        if (!await this.$refs.LineNotifyConfirmDialog.verify('請綁定 LINE  開啟巧巧郎推播通知，確保即時接收客服回覆')) {
          return
        }

        if (this.isCreate) {
          const params = {
            ...this.model,
            pclid: this.pclid,
            oid: this.oid,
            ignoreLimit: '1',
          }
          if (this.$route.query.listLen > 0) {
            params.ignoreLimit = '1'
          }
          if (this.$store.state.userData.actor & 2) {
            // params.tag = 'actor2'
            params.ignoreLimit = '1'
          }
          if (this.$store.state.project === 'mgb-pc') {
            params.ignoreLimit = '1'
          }
          const res = await this.$store.dispatch('comment/createWorkOrder', params)
          if (!res.data.error) {
            // this.$emit('update:cid', res.data.model.cid)
            this.model.content = ''
            this.model.upyunFiles = []
            this.$snackbar('已提交申訴', { color: 'success' })
            this.$emit('created')
            this.closeDialog()
          }
        } else {
          const res = await this.$store.dispatch('comment/createReply', {
            ...this.model,
            parent: this.cid,
          })
          if (!res.data.error) {
            this.model.content = ''
            this.model.upyunFiles = []
            this.fetchDetail()
            this.$emit('replied')
          }
        }
      } finally {
        this.submitLoading = false
      }
    },
    handleCreated () {
      this.$snackbar('已提交申訴', { color: 'success' })
      this.$emit('created')
      this.closeDialog()
    },
    handleLiked () {
      this.closeDialog()
      this.$emit('reload')
    },
    async handleClickShowEdit () {
      this.showEdit = true
      await this.$nextTick()
      this.$refs.scroller.scrollTop = this.$refs.scroller.scrollHeight
      // window.scrollTo(0, document.scrollingElement.scrollHeight)
    },
    hanldeClickContent (e) {
      const el = e.target.closest('a')
      if (el && el.tagName === 'A') {
        const href = el.getAttribute('href')
        window.open(href)
      }
    }
  }
}
</script>
